module.exports = __webpack_public_path__ + "img/eyfBwulg.231c1d88.svg";